import React, { useState, createContext, useContext } from 'react';
// Define the types for our context
type StrategyFilterType = 'All' | 'Long-Term Hold' | 'Short-Term Flip';
interface FilterContextType {
  strategyFilter: StrategyFilterType;
  setStrategyFilter: (filter: StrategyFilterType) => void;
}
// Create the context with default values
const FilterContext = createContext<FilterContextType>({
  strategyFilter: 'All',
  setStrategyFilter: () => {}
});
// Create a provider component
export const FilterProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [strategyFilter, setStrategyFilter] = useState<StrategyFilterType>('All');
  return <FilterContext.Provider value={{
    strategyFilter,
    setStrategyFilter
  }} data-id="element-88">
      {children}
    </FilterContext.Provider>;
};
// Create a custom hook for using the context
export const useFilter = () => useContext(FilterContext);